import React from "react";
import { useCountUp } from "../../hooks/useCountUp";
import type { Stat } from "./useLandingPage";

const StatCounter: React.FC<{ stat: Stat }> = ({ stat }) => {
  const value = useCountUp(stat.value);
  const display = Number.isInteger(stat.value) ? Math.round(value).toLocaleString() : value.toFixed(1);

  return (
    <div className="text-center">
      <p className="eos-gradient-text text-3xl font-bold sm:text-4xl">
        {display}
        {stat.suffix}
      </p>
      <p className="mt-1 text-sm text-slate-400">{stat.label}</p>
    </div>
  );
};

export default StatCounter;
